<template>
  <div class="p-material-setting">
    <div v-if="materialLibraryEnabled" class="p-material-setting__operate">
      <plv-button @click="distributeMaterialResource('add')">添加资源</plv-button>
      <plv-button @click="distributeMaterialResource('recycle')">回收资源</plv-button>
    </div>
    <div class="p-material-setting-form">
      <div class="p-material-setting-form__title">
        {{ materialLibraryEnabled ? '资源分配' : '剩余资源' }}
      </div>
      <plv-column>
        <plv-column-item prefix="空间">{{ materialData.space }} GB</plv-column-item>
        <plv-column-item prefix="流量">{{ materialData.flow }} GB</plv-column-item>
      </plv-column>
    </div>

    <materialDistribute ref="distributeDialog" :visible.sync="distributeDialogVisible" @updateSuccess="updateSuccess" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import materialDistribute from './components/materialDistribute.vue';
import accountInfoMixin from '@/mixins/accountInfo';

export default {
  components: {
    materialDistribute
  },
  mixins: [accountInfoMixin],
  data() {
    return {
      distributeDialogVisible: false,
      materialData: {
        space: '',
        flow: '',
      },
      unionId: ''
    };
  },
  computed: {
    ...mapGetters({
      subAccountInfo: 'account/subAccountInfo'
    }),
  },
  watch: {
    subAccountInfo: {
      handler(value) {
        this.materialData.space = value.avalableMaterialSpace;
        this.materialData.flow = value.avalableMaterialTraffic;
      },
      immediate: true
    }
  },
  created() {
    const { params: { id } } = this.$route;
    if (id) this.unionId = id;
  },
  methods: {
    distributeMaterialResource(type = 'add') {
      this.$refs.distributeDialog.open(type, {
        ...this.materialData,
        unionId: this.unionId
      });
    },
    async updateSuccess(form) {
      this.$toast.success('保存成功');
      this.distributeDialogVisible = false;
      const subAccountInfo = { ...this.subAccountInfo };
      subAccountInfo.avalableMaterialTraffic += form.materialFlow;
      subAccountInfo.avalableMaterialSpace += form.materialSpace;
      this.$store.commit('account/setSubAccountInfo', subAccountInfo);
    }
  }
};
</script>

<style lang="scss" scoped>
.p-material-setting {
  padding: 0 18px;
  .p-material-setting-form__title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  .p-material-setting-form-item__unit {
    margin-left: 8px;
  }
  .p-material-setting__operate {
    margin: 20px 0;
    .plv-button {
      margin-right: 20px;
    }
  }
}
</style>
